import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
import { Eye, EyeOff } from 'lucide-react';
export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Email dan kata sandi wajib diisi');
      return;
    }
    setIsLoading(true);
    // 🔥 REAL LOGIN SUPABASE
    const {
      error
    } = await login(email, password);
    if (error) {
      setError('Email atau password salah');
      setIsLoading(false);
      return;
    }
    navigate(from, {
      replace: true
    });
  };
  return <div className="min-h-screen flex items-center justify-center bg-pastel-grey-light px-4 sm:px-6 lg:px-8" data-id="element-390">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="max-w-md w-full space-y-8 bg-white p-8 sm:p-10 rounded-3xl shadow-apple" data-id="element-391">
        {/* HEADER */}
        <div className="text-center" data-id="element-392">
          <Link to="/" className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-pastel-blue mb-6" data-id="element-393">
            <span className="text-2xl font-bold text-dark" data-id="element-394">BK</span>
          </Link>

          <h2 className="text-3xl font-bold tracking-tight text-[#7C1A32]" data-id="element-395">
            Selamat Datang
          </h2>

          <p className="mt-2 text-sm text-[#956A80]" data-id="element-396">
            Masuk ke akun Ruang BK Anda
          </p>
        </div>

        {/* FORM */}
        <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-397">
          <div className="space-y-4" data-id="element-398">
            <Input label="Email" type="email" placeholder="nama@email.com" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-399" />

            {/* PASSWORD */}
            <div className="relative" data-id="element-400">
              <Input label="Kata Sandi" type={showPassword ? 'text' : 'password'} placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-401" />

              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-9 text-gray-500 hover:text-gray-700" data-id="element-402">
                {showPassword ? <EyeOff size={20} data-id="element-403" /> : <Eye size={20} data-id="element-404" />}
              </button>
            </div>
          </div>

          {/* ERROR */}
          {error && <motion.p initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} className="text-sm text-red-500 text-center" data-id="element-405">
              {error}
            </motion.p>}

          {/* BUTTON */}
          <Button type="submit" fullWidth isLoading={isLoading} size="lg" data-id="element-406">
            Masuk
          </Button>
        </form>

        {/* FOOTER */}
        <div className="text-center mt-6" data-id="element-407">
          <p className="text-sm text-gray-600" data-id="element-408">
            Belum punya akun?{' '}
            <Link to="/register" className="font-medium text-dark hover:underline" data-id="element-409">
              Daftar sekarang
            </Link>
          </p>
        </div>
      </motion.div>
    </div>;
}